import { scales, brandColors } from './colors.js';
var light = {
  mode: 'light',
  background: {
    base: scales.white,
    primary: scales.white,
    secondary: scales.white
  },
  elevatedSurface: {
    default: scales.white,
    hover: scales.gray10,
    pressed: scales.gray15,
    disabled: scales.white
  },
  accent: {
    default: brandColors.light.default,
    on: scales.white,
    hover: brandColors.light.hover,
    pressed: brandColors.light.pressed,
    disabled: brandColors.light.disabled,
    onDisabled: scales.white
  },
  text: {
    primary: scales.gray90,
    secondary: scales.gray30,
    placeholder: scales.gray30,
    disabled: scales.gray20
  },
  icon: {
    primary: scales.gray90,
    secondary: scales.gray30,
    placeholder: scales.gray30,
    disabled: scales.gray20
  },
  neutralButton: {
    default: scales.gray10,
    on: scales.gray90,
    hover: scales.gray5,
    pressed: scales.gray15,
    disabled: scales.gray10,
    onDisabled: scales.gray20
  },
  ghostButton: {
    default: scales.transparentWhite0,
    on: scales.white,
    outline: scales.white,
    hover: scales.transparentWhite15,
    pressed: scales.transparentBlack10,
    disabled: scales.transparentWhite50
  },
  toast: {
    default: scales.gray90,
    on: scales.white
  },
  system: {
    info: {
      default: scales.blue50,
      surface: scales.blue5
    },
    success: {
      default: scales.green40,
      surface: scales.green5
    },
    warning: {
      default: scales.orange50,
      surface: scales.orange5
    },
    danger: {
      default: scales.red50,
      hover: scales.red30,
      pressed: scales.red60,
      disabled: scales.red10,
      surface: scales.red5
    }
  },
  hierarchy: {
    h1: scales.gray90,
    h2: scales.gray30,
    h3: scales.gray20,
    h4: scales.gray15,
    h5: scales.gray10,
    h6: scales.gray5
  }
};
var dark = {
  mode: 'dark',
  background: {
    base: scales.black,
    primary: scales.gray90,
    secondary: scales.gray80
  },
  elevatedSurface: {
    default: scales.gray90,
    hover: scales.gray80,
    pressed: scales.black,
    disabled: scales.gray90
  },
  accent: {
    default: brandColors.dark.default,
    on: scales.white,
    hover: brandColors.dark.hover,
    pressed: brandColors.dark.pressed,
    disabled: brandColors.dark.disabled,
    onDisabled: scales.transparentWhite50
  },
  text: {
    primary: scales.gray5,
    secondary: scales.gray20,
    placeholder: scales.gray20,
    disabled: scales.gray30
  },
  icon: {
    primary: scales.gray5,
    secondary: scales.gray20,
    placeholder: scales.gray20,
    disabled: scales.gray30
  },
  neutralButton: {
    default: scales.gray60,
    on: scales.gray5,
    hover: scales.gray80,
    pressed: scales.gray50,
    disabled: scales.gray60,
    onDisabled: scales.gray30
  },
  ghostButton: {
    default: scales.transparentBlack0,
    on: scales.white,
    outline: scales.white,
    hover: scales.transparentWhite15,
    pressed: scales.transparentBlack10,
    disabled: scales.transparentWhite50
  },
  toast: {
    default: scales.white,
    on: scales.gray90
  },
  system: {
    info: {
      default: scales.blue50,
      surface: scales.blue5
    },
    success: {
      default: scales.green40,
      surface: scales.green5
    },
    warning: {
      default: scales.orange50,
      surface: scales.orange5
    },
    danger: {
      default: scales.red50,
      hover: scales.red40,
      pressed: scales.red70,
      disabled: scales.red90,
      surface: scales.red5
    }
  },
  hierarchy: {
    h1: scales.gray5,
    h2: scales.gray20,
    h3: scales.gray30,
    h4: scales.gray50,
    h5: scales.gray60,
    h6: scales.gray80
  }
};
export { dark as darkColorTokens, light as lightColorTokens };